module.exports = __webpack_public_path__ + "img/bm01.5625e503.png";